<script>	
	import TitleScreen from "../components/TitleScreen.svelte";
	import FTSection from "../components/FTSection.svelte";
    import State from '../stores/State.js';

    export let started = $State.started;
</script>

<main>
    <TitleScreen bind:started />
    {#if started}
        <FTSection />
    {/if}
</main>

<style>
</style>